export default __webpack_public_path__ + "./image/da8038d5181b9821a6bb61fdef868d87.png";